export class Ajax{
    constructor(button, html){
        this.button = button;
        this.html = html;
        if(this.button.data('type') == 'self'){
            this.direct();
        }
    }
    direct(){
        let self = this;
        $.ajax({
            type: self.button.data('method'),
            url: self.button.data('action'),
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            success: function(){
                self.html += ''
                    + '<a href="#" class="btn btn-sm btn-light border" data-dismiss="modal"><i class="fas fa-check text-primary"></i> Okay</a>'
                $('#mdlPrompt .modal-body').html(self.html);
                $('#mdlPrompt').modal('show');
            },
            error: function(){
                alert('error');
            }
        });
    }
}